// @ts-strict-ignore
import { getJson, postJson } from 'utils/http';

import { ApiNotification } from './types/ApiNotification';

export const fetchNotifications = (): Promise<Array<ApiNotification>> =>
  getJson('/data/notifications').then(({ notifications }) => notifications);

export const dismissNotifications = (notificationIds: Array<string>) =>
  postJson('/data/notifications-read', {
    notificationIds,
  }).then(({ notifications }) => notifications);
